export const AI_TOPICS = {
  PET_TRAVEL: 'pet_travel',
  PET_STORE: 'pet_store',
  PET_GROOMING: 'pet_grooming',
  PET_BOARDING: 'pet_boarding',
  PET_TRAINING: 'pet_training',
  PET_ADOPTION: 'pet_adoption',
  PET_NUTRITION: 'pet_nutrition',
  PET_BEHAVIOR: 'pet_behavior',
  PET_TOXICITY: 'pet_toxicity',
  PET_DISASTER_PREP: 'pet_disaster_prep',
};

const KNOWN_TOPICS = new Set(Object.values(AI_TOPICS));

export function assertKnownTopic(topic) {
  if (
    topic != null &&
    !KNOWN_TOPICS.has(topic) &&
    process.env.NODE_ENV !== 'production'
  ) {
    // eslint-disable-next-line no-console
    console.warn(
      `[AISearch] Unknown topic received: ${JSON.stringify(topic)}. ` +
        'Update intentToVideos / aiSearchTopics.'
    );
  }
}
